import { TranslateService } from '@ngx-translate/core';

export enum panelID {
  account = 'account',
  payment = 'payment',
  language = 'language',
  permissions = 'permissions',
  advanced = 'advanced',
  sitesManagement = 'sitesManagement',
  customAttributes = 'customAttributes',
  aiAssist = 'aiAssist',
  alerts = 'alerts',
  billableUsage = 'billableUsage',
  feedback = 'feedback',
  integrations = 'integrations',
  events = 'events',
  branding = 'branding',
  sessions = 'sessions',
}

export interface PanelData {
  id: panelID;
  name: string;
  description: string;
}

export enum TabId {
  API = 'api',
  WEBHOOKS = 'webhooks',
  LTI = 'lti',
  LMS_AND_SIS = 'lms_and_sis',
}

export class SettingsConstantsTransformer {
  readonly PANELS: {
    [key: string]: PanelData;
  };

  constructor(private translateService: TranslateService) {
    this.PANELS = {
      ACCOUNT: {
        id: panelID.account,
        name: this.translateService.instant('Account'),
        description: this.translateService.instant('Adjust contact details and preferences'),
      },
      PAYMENT: {
        id: panelID.payment,
        name: this.translateService.instant('Billing & Payment'),
        description: this.translateService.instant('Choose the plan that’s best for you'),
      },
      LANGUAGE: {
        id: panelID.language,
        name: this.translateService.instant('Language & Region'),
        description: this.translateService.instant("Define your account's language and region"),
      },
      PERMISSIONS: {
        id: panelID.permissions,
        name: this.translateService.instant('Permissions'),
        description: this.translateService.instant(
          'Admin permissions for all Spaces in your institution',
        ),
      },
      ADVANCED: {
        id: panelID.advanced,
        name: this.translateService.instant('Advanced'),
        description: this.translateService.instant('Adjust preferences in Spaces'),
      },
      SITES_MANAGEMENT: {
        id: panelID.sitesManagement,
        name: this.translateService.instant('Sites'),
        description: this.translateService.instant('Manage sites in your institution'),
      },
      CUSTOM_ATTRIBUTES: {
        id: panelID.customAttributes,
        name: this.translateService.instant('Custom Attributes'),
        description: this.translateService.instant(
          'Categorizes Spaces, events and users through a custom tag',
        ),
      },
      AI_ASSIST: {
        id: panelID.aiAssist,
        name: this.translateService.instant('AI Assist'),
        description: this.translateService.instant(
          'Optimize your institution with artificial intelligence',
        ),
      },
      BILLABLE_USAGE: {
        id: panelID.billableUsage,
        name: this.translateService.instant('Plans & Billing'),
        description: this.translateService.instant(
          'Manage your institution’s billing details and view billing usage',
        ),
      },
      FEEDBACK: {
        id: panelID.feedback,
        name: this.translateService.instant('Feedback'),
        description: this.translateService.instant(
          'Configure what happens after an event ends inside a Space',
        ),
      },
      INTEGRATIONS: {
        id: panelID.integrations,
        name: this.translateService.instant('API & Integrations'),
        description: this.translateService.instant(
          'Configure API & Integration settings for your institution',
        ),
      },
      ALERTS: {
        id: panelID.alerts,
        name: this.translateService.instant('Alerts'),
        description: this.translateService.instant(
          'How admins get notified on alerts in the institution',
        ),
      },
      EVENTS: {
        id: panelID.events,
        name: this.translateService.instant('Events'),
        description: this.translateService.instant(
          'Configure behavior for events scheduled in Spaces',
        ),
      },
      BRANDING: {
        id: panelID.branding,
        name: this.translateService.instant('Branding'),
        description: this.translateService.instant("Customize your institution's branding"),
      },
      SESSIONS: {
        id: panelID.sessions,
        name: this.translateService.instant('Sessions'),
        description: this.translateService.instant('Adjust settings for sessions'),
      },
    };
  }

  get providersToNames() {
    return this.PANELS;
  }
}
